<template>
    <div class="story-maker-sticker story-maker-sticker-image">
        <img class="img-change-color" :src="require('@/assets/img/instagram/ehf.png')">
        <p class="text-finish">{{ $t('dash.post-creator.story.done') }}</p>
        <div class="sticker-image">
           <img data-check-load class="selectDisable" draggable="false" :src="files[idFile].url">
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            idFile: Number | String,
            files:Object
        },
    }
</script>
